export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20fashion%20concept%20with%20soft%20gradient%20of%20warm%20cream%20and%20terracotta%20tones%2C%20minimalist%20product%20silhouettes%20in%20an%20organized%20grid%2C%20gentle%20diffused%20lighting%2C%20clean%20sophisticated%20modern%20aesthetic%2C%20editorial%20fashion%20with%20airy%20negative%20space%2C%20calm%20elegant%20atmosphere&width=1800&height=900&seq=sugargoo-hero-bg-2026&orientation=landscape"
          alt="Sugargoo Spreadsheet product research database background"
          className="w-full h-full object-cover object-top"
          title="Sugargoo Spreadsheet 2026 Product Research Database"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-200/50 mb-6">
          <div className="w-2 h-2 rounded-full bg-primary-500"></div>
          <span className="text-xs md:text-sm text-foreground-700 font-medium">Updated Weekly — 2026 Edition</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          Sugargoo Spreadsheet 2026
        </h1>
        <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          The ultimate product research database and shopping guide. Discover trending items, explore organized categories, and shop smarter with our curated Sugargoo Spreadsheet collection.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm md:text-base hover:bg-background-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8 md:mt-10">
          {['Updated Weekly', 'Product Research Database', 'Organized Categories', 'Trusted Resource'].map((badge) => (
            <div key={badge} className="flex items-center gap-1.5 text-white/70 text-xs md:text-sm">
              <i className="ri-check-line text-primary-400 text-sm"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}